// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XOw1Q","rootNoMargin":"styles_rootNoMargin__310uI"};